// packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';

// styles
import './FormOption.less';

class FormOption extends Component {
    static propTypes = {
      activeKey: PropTypes.string,
      children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
        PropTypes.string,
        PropTypes.number,
      ]),
      eventKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),

      onClick: PropTypes.func,
    };

    static defaultProps = {
      selected: false,
      children: '',
    };

    onClick = () => this.props.onClick(ReactDOM.findDOMNode(this.refs.radio).value);

    render() {
      const {
        eventKey,
        activeKey,
        children,
      } = this.props;

      const id = `form-options-${eventKey}-hash-${_.random(9999)}`;

      const isSelected = activeKey === eventKey;

      return (
        <div
            onClick={this.onClick}
            className={`form-option ${isSelected ? 'selected' : ''}`}>
          <label className="option" htmlFor={id}>
            <input
                        ref="radio"
                        type="radio"
                        id={id}
                        value={eventKey}
                        onChange={() => null}
                        checked={isSelected}
                        className="form-radio" /> {children}
          </label>
        </div>
      );
    }
}

export default FormOption;



/** WEBPACK FOOTER **
 ** ./src/components/Modules/FormOption/FormOption.js
 **/